/**
 * Hook personalizado para manejar la autenticación del usuario
 * Proporciona datos del usuario autenticado y funciones de utilidad
 */

import { useState, useEffect } from 'react';

export const useAuth = () => {
  const [user, setUser] = useState(null);
  const [asesorId, setAsesorId] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const getAuthenticatedUser = () => {
      try {
        const usuario = localStorage.getItem('usuario');
        const token = localStorage.getItem('token');
        const isAuthFlag = localStorage.getItem('isAuthenticated');
        
        if (usuario && token && isAuthFlag === 'true') {
          const userData = JSON.parse(usuario);
          setUser({
            ...userData, 
            id: userData.id,
            instanciaId: userData.instanciaId 
          });
          setAsesorId(userData.id); // userData.id es el asesor_id
          setIsAuthenticated(true);
          
          console.log('🔐 [useAuth] Usuario autenticado:', {
            id: userData.id,
            name: userData.name,
            username: userData.username,
            email: userData.email,
            rol: userData.rol,
            instanciaId: userData.instanciaId
          });
        } else {
          console.warn('⚠️ [useAuth] Usuario no autenticado');
          setUser(null);
          setAsesorId(null);
          setIsAuthenticated(false);
        }
      } catch (error) {
        console.error('❌ [useAuth] Error obteniendo usuario:', error);
        setUser(null);
        setAsesorId(null);
        setIsAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    };

    getAuthenticatedUser();

    // Escuchar cambios en localStorage (por si se actualiza en otra pestaña)
    const handleStorageChange = (e) => {
      if (e.key === 'usuario' || e.key === 'token' || e.key === 'isAuthenticated') {
        getAuthenticatedUser();
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  // Función para obtener información de instancia del asesor
  const getAsesorInstanceInfo = async () => {
    if (!asesorId) return null;
    
    try {
      const response = await fetch(`/asesor-instance-info`);
      const data = await response.json();
      
      if (data.success) {
        console.log(`🎯 [useAuth] Información de instancia para asesor ${asesorId}:`, data.instanceInfo);
        return data;
      }
    } catch (error) {
      console.error('❌ [useAuth] Error obteniendo información de instancia:', error);
    }
    
    return null;
  };

  // Función para logout
  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('usuario');
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('requiresPasswordChange');
    
    setUser(null);
    setAsesorId(null);
    setIsAuthenticated(false);
    
    console.log('🔐 [useAuth] Sesión cerrada');
    window.location.href = '/login';
  };

  return {
    user,
    asesorId,
    isLoading,
    isAuthenticated,
    getAsesorInstanceInfo,
    logout
  };
};